import { render, staticRenderFns } from "./aRmsStrategyAvailabilityColumns.vue?vue&type=template&id=6f69ece4&scoped=true"
import script from "./aRmsStrategyAvailabilityColumns.vue?vue&type=script&lang=js"
export * from "./aRmsStrategyAvailabilityColumns.vue?vue&type=script&lang=js"
import style0 from "./aRmsStrategyAvailabilityColumns.vue?vue&type=style&index=0&id=6f69ece4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69ece4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VCol,VRow})
